export default __webpack_public_path__ + "src/assets/logo-text.2734b596d04b0000a7568cfd35f3115c.svg";